import React, {Component} from 'react'
import TimeField from 'react-simple-timefield'

import FieldsGroup from '../../../struct/FieldsGroup'
import Field from '../../../struct/Field'
import classnames from 'classnames'

import styles from './RegionSettings.less'
import Select from 'lib/struct/form/Select'
import RegionCatalogStocksSelect from './RegionCatalogStocksSelect'
import Hint from '../../../struct/Hint'
import Checkbox from 'lib/control/Checkbox'
import InputText from 'lib/struct/form/InputText'
import RegionsGroups from './RegionsGroups'
import Button from "lib/control/Button"
import ReactPaginate from "react-paginate"
import Iconui from 'lib/struct/iconui/Iconui';

const {
    'region-block': regionBlock,
    'region-header': regionHeader,
    'region-title': regionTitle,
    'region-settings-toggler': regionSettingsToggler,
    'region-settings-toggler-btn': regionSettingsTogglerBtn,
    'region-content': regionContent,
    'fields-block': fieldsBlock,
    'fields-block-title': fieldsBlockTitle,
    'period-block': periodBlock,
    'time-span': timeSpan,
    'time-input': timeInput,
    'day-input': dayInput,
    'text-input': textInput,
    'pickup-title': pickupTitle,
    'pickup-hint': pickupHint,
    'pickup-flex': pickupFlex,
    'table': table,
		'table-block': tableBlock,
    'checkbox-block': checkboxBlock,
    'order-method-block': orderMethodBlock,
    'add-point-block': addPointBlock,
    'methods-table': methodsTable,
    'day-cell': dayCell,
    'tr-error': trError,
    'region-header-id': regionHeaderId,
    'import-export': importExport,
    'clear-pvz-btn': clearPvzListBtn,
    'paginate-compare': paginateCompare,
} = styles

const RegionStockSelectionOptions = [
    {
        label: 'По умолчанию',
        value: 'DEFAULT',
    },
    {
        label: 'Все склады',
        value: 'ALL',
    },
    {
        label: 'Выбрать...',
        value: 'SELECTED_STOCKS',
    }
]

const TestTime = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/

const workDays = [
    false, true, true, true, true, true, false
]

const pickupWorkDays = [
    false, true, true, true, true, true, false
]

const MAX_COUNT_INTERVALS = 5
const ERROR_INTERVAL_INTERSECT = 'Интервалы пересекаются'
const ERROR_INTERVAL_FORMAT = 'Неверный формат интервалов'

const RegionHeader = ({title, isHome, isNew, onSelectRegion, onDeleteRegion, id}) => {
    return (
        <div className={regionHeader}>
            <div className={regionTitle}>
                <h2 onClick={() => onSelectRegion()}>
                    {title}
                </h2>
                {isHome ? <span>(домашний регион)</span> : null}
            </div>
            {!isNew ?
                <div className={regionSettingsToggler}>
                    <span className={classnames(regionSettingsTogglerBtn, regionHeaderId)}>
                        Id: {id}
                    </span>
					<span className={regionSettingsTogglerBtn}>

						<Iconui name={"settings"} />
						<a onClick={() => onSelectRegion()}>
							Настройки
						</a>
					</span>
                    {!isHome &&
                    <span className={regionSettingsTogglerBtn}>
						<Iconui name={"delete"} />
						<a onClick={() => onDeleteRegion()}>
							Удалить
						</a>
					</span>
                    }
                </div>
                : null}
        </div>
    )
}

export default class RegionSettings extends Component {
    constructor(props) {
        super(props)
        const {region} = props
        region.pvzList = region.pvzList ? region.pvzList : []
        region.pvzCount = region.pvzCount ? region.pvzCount : 0
        region.pvzPage = region.pvzPage ? region.pvzPage - 1 : 0
        region.pvzPageCount = Math.ceil(region.pvzCount / 10)
        region.payment_methods = region.payment_methods ? region.payment_methods : []
        region.courierAllowed = typeof region.courierAllowed === 'string' ? region.courierAllowed === 'true' : region.courierAllowed
        region.pickupAllowed = typeof region.pickupAllowed === 'string' ? region.pickupAllowed === 'true' : region.pickupAllowed
        region.days = region.days ? region.days : Object.assign([], workDays)
        region.days.map((day, idx) => {
            if (typeof day === 'string') {
                region.days[idx] = day === 'true'
            }
        })
        region.intervals = region.intervals ? region.intervals : [{
            timeFrom: '10:00',
            timeTo: '19:00',
            days: region.days,
        }]
        region.intervals.map((interval, key) => {
            interval.days.map((day, idx) => {
                if (typeof day === 'string') {
                    region.intervals[key].days[idx] = day === 'true'
                }
            })
        })
        region.pvzList.map((pvz) => {
            pvz.pvz_id = pvz.pvz_id ? pvz.pvz_id : 'pickup.' + pvz.id
            if (pvz.pickupDays) {
                pvz.pickupDays.map((day, idx) => {
                    if (typeof day === 'string') {
                        pvz.pickupDays[idx] = day === 'true'
                    }
                })
            } else {
                pvz.pickupDays = Object.assign([], pickupWorkDays)
            }
        })
        region.deliveryId = region.deliveryId ? region.deliveryId : 0
        region.pickupId = region.pickupId ? region.pickupId : 0
        region.paymentIds = region.paymentIds ? region.paymentIds : {}
        region.errors = []
        region.error_message = ''
        region.query = ''
        this.state = region
    }

    onAddInterval() {
        let newIntervals = this.state.intervals
        if(newIntervals.length < MAX_COUNT_INTERVALS) {
            newIntervals.push({
                timeFrom: '10:00',
                timeTo: '19:00',
                days: Object.assign([], this.state.days),
            })
            this.setState({intervals: newIntervals})
            this.props.region['intervals'] = newIntervals
        }
    }

    onDeleteInterval = (idx) => {
        let newIntervals = this.state.intervals.filter((_, i) => i !== idx)
        this.setState({intervals: newIntervals})
        this.props.region['intervals'] = newIntervals
    }

    onSelectRegion = () => {
        const {region, onSelectRegion, isNew} = this.props

        if (!isNew) {
            onSelectRegion(region.id)
        }
    }

    onDeleteRegion = () => {
        const {region, onDeleteRegion, isNew} = this.props

        if (!isNew) {
            onDeleteRegion(region.id)
        }
    }

    changeFieldValue = (fieldName, value) => {
        this.setState({[fieldName]: value})
        this.props.region[fieldName] = value
    }

    togglePayments = (method_id, toggle) => {
        const {payment_methods} = this.state
        let newPaymentMethods = payment_methods

        if (toggle) {
            newPaymentMethods.push(method_id)
        } else {
            newPaymentMethods = newPaymentMethods.filter(id => id !== method_id)
        }

        this.setState({payment_methods: newPaymentMethods})
        this.props.region['payment_methods'] = newPaymentMethods
    }

    changePaymentsIds = (method_id, id) => {
        const {paymentIds} = this.state
        let newPaymentIds = paymentIds

        newPaymentIds[method_id] = id

        this.setState({paymentIds: newPaymentIds})
        this.props.region['paymentIds'] = newPaymentIds
    }

    new_pvz = 0

    onAddPvz = () => {
        let newPvzList = this.state.pvzList
        this.new_pvz++
        newPvzList.push({
            'name': 'Новая точка самовывоза',
            'pvz_id': 'pickup.' + this.new_pvz,
            'fromDate': 1,
            'toDate': 2,
            'time': '14:00',
            'pickupDays': Object.assign([], pickupWorkDays)
        })
        this.setState({pvzList: newPvzList})
        this.props.region['pvzList'] = newPvzList
    }

    onDeletePvz = (idx) => {
        // this.props.context.pvz_to_delete.push(this.state.pvzList[idx]['id'])
        this.updatePvz(idx, this.state.pvzList[idx], true)
        let newPvzList = this.state.pvzList.filter((_, i) => i !== idx)
        this.setState({pvzList: newPvzList})
        this.props.region['pvzList'] = newPvzList
    }

    changePvz = (idx, fieldName, value) => {
        if(this.pvzUpdateTimers[idx]) {
            clearTimeout(this.pvzUpdateTimers[idx])
        }
        this.pvzUpdateTimers[idx] = setTimeout(() => {

            if (fieldName === 'name' && value.length > 50) {
                value = value.slice(0, 50)
            }
            let newPvzList = this.state.pvzList
            newPvzList[idx][fieldName] = value
            this.setState({pvzList: newPvzList})
            this.props.region['pvzList'] = newPvzList
            this.updatePvz(idx, newPvzList[idx])

        }, 500)
    }

    changeDaysValue = (interval_id, idx, value) => {
        let newIntervals = this.state.intervals
        newIntervals[interval_id].days[idx] = value
        this.setState({intervals: newIntervals})
        this.props.region['intervals'] = newIntervals
    }

    findIntersection = (intervals, start, end) => {
        return intervals.findIndex(
            interval => (start < interval.timeTo) && (interval.timeFrom < end)
        )
    }

    validateIntervals = (newIntervals) => {
        let count = 0;
        let errors = []
        for (let i = 0; i < newIntervals.length; i++) {

            if ( !TestTime.test( newIntervals[i].timeFrom ) || !TestTime.test( newIntervals[i].timeTo)) {
                errors.push(i)
            } else if(newIntervals[i].timeFrom >= newIntervals[i].timeTo) {
                errors.push(i)
            }
        }
        if(errors.length > 0) {
            this.setState({error_message: ERROR_INTERVAL_FORMAT})
            return errors
        }
        while(count+1 < newIntervals.length) {
            let testInterval = newIntervals[count];
            let testIntervals = newIntervals.filter((_, i) => i !== count)
            let idx = this.findIntersection(testIntervals, testInterval.timeFrom, testInterval.timeTo)
            idx += idx >= 0 ? 1 : 0;
            if(idx >= 0 && idx !== count) {
                errors.push(count)
                errors.push(idx)
            }
            count++;
        }
        console.log(errors)
        if(errors.length > 0) {
            this.setState({error_message: ERROR_INTERVAL_INTERSECT})
        }
        return errors;
    }

    changeTimeValue = (interval_id, time, idx, value) => {
        let newIntervals = this.state.intervals
        let times = newIntervals[interval_id][time].split(':')
        times[idx] = value
        newIntervals[interval_id][time] = times.join(':')
        let errors = this.validateIntervals(newIntervals)

        if ( errors.length === 0 ) {
            this.setState({intervals: newIntervals})
            this.props.region['intervals'] = newIntervals
        }
        this.setState({errors: errors})
    }

    changePickupDaysValue = (idx, day, value) => {
        let newPvzList = this.state.pvzList
        newPvzList[idx]['pickupDays'][day] = value
        this.setState({pvzList: newPvzList})
        this.props.region['pvzList'] = newPvzList
        this.updatePvz(idx, newPvzList[idx])
    }

    pvzUpdateTimers = []
    updatePvzs = []

    updatePvz = (idx, pvz, del=false) => {
        if(this.updatePvzs[idx]) return
        this.updatePvzs[idx] = true

            $.post(
                '?plugin=pokupki&module=Backend&action=updatePvz',
                {'pvz': pvz, 'delete': del, 'region_id': this.state.id, 'campaign_id': this.props.campaign.id},
                response => {

                    if (response.status === 'error') {
                        alert(response.errors[0].message)
                    } else {
                        if (!del) {
                            response.data.pvz.pvz_id = pvz.pvz_id ? response.data.pvz.pvz_id : 'pickup.' + response.data.pvz.id
                            if (response.data.pvz.pickupDays) {
                                response.data.pvz.pickupDays.map((day, i) => {
                                    if (typeof day === 'string') {
                                        response.data.pvz.pickupDays[i] = day === 'true'
                                    }
                                })
                            } else {
                                response.data.pvz.pickupDays = Object.assign([], pickupWorkDays)
                            }
                            let newPvzList = this.state.pvzList
                            newPvzList[idx] = response.data.pvz
                            this.setState({pvzList: newPvzList})
                            this.props.region['pvzList'] = newPvzList
                        }
                    }
                    delete this.updatePvzs[idx]
                }
            )

    }

    loadInfo = false

    loadPvzInfo = (page, query = '') => {
        if((page === this.state.pvzPage  && query === this.state.query) || page <0 || this.loadInfo)
            return
        this.loadInfo = true
        $.post(
            '?plugin=pokupki&module=Backend&action=getPvzInfo',
            {'region_id': this.state.id, 'page': ++page, 'query': query},
            response => {

                if (response.status === 'error') {
                    alert(response.errors[0].message)
                } else {

                    response.data.items.map((pvz) => {
                        pvz.pvz_id = pvz.pvz_id ? pvz.pvz_id : 'pickup.' + pvz.id
                        if (pvz.pickupDays) {
                            pvz.pickupDays.map((day, idx) => {
                                if (typeof day === 'string') {
                                    pvz.pickupDays[idx] = day === 'true'
                                }
                            })
                        } else {
                            pvz.pickupDays = Object.assign([], pickupWorkDays)
                        }
                    })

                    this.setState({
                        query: query,
                        pvzList: response.data.items,
                        pvzCount: response.data.count,
                        pvzPage: Number(response.data.page) - 1,
                        pvzPageCount: Math.ceil(response.data.count / 10)
                    })
                }
                this.loadInfo = false
            },
            'json'
        )
    }

    loadPvzByQuery = (query) => {
        this.loadPvzInfo(0, query)
    }

    clearPvzList = () => {
        let conf = confirm("вы точно хотите удалить все ПВЗ?");
        if(conf) {
            for (let i = 0; i < this.state.pvzList.length; i++) {
                this.props.context.pvz_to_delete.push(this.state.pvzList[i]['id'])
            }
            this.setState({pvzList: []})
            this.props.region['pvzList'] = []
            this.props.context.saveSettings()
        }
    }

    render() {
        const {region, isActive, isHome, isNew, context, campaign} = this.props
        let content = undefined
        let createRegionContent = undefined
        let createAddButton = undefined

        if (isNew) {
            createRegionContent = (
                <React.Fragment>
                    <FieldsGroup className={fieldsBlock}>
                        <Field label="Название группы регионов">
                            <InputText
                                defaultValue={''}
                                onChange={e => this.changeFieldValue('name', e.target.value)}
                                disabled={false}
                                readOnly={false}
                                placeholder={'Введите любое название'}
                            />
                        </Field>
                    </FieldsGroup>
                    <FieldsGroup className={fieldsBlock}>
                        <div className={fieldsBlockTitle}>
                            1. Регионы доставки
                        </div>
                        <RegionsGroups
                            campaign={campaign}
                            region={region}
                            settings={{
                                include: '1',
                                regions: []
                            }}/>
                    </FieldsGroup>
                </React.Fragment>
            )
        } else if (!isHome) {
            createRegionContent = (
                <React.Fragment>
                    <FieldsGroup className={fieldsBlock}>
                        <Field label="Название группы регионов">
                            <InputText
                                defaultValue={region.name}
                                onChange={e => this.changeFieldValue('name', e.target.value)}
                                disabled={false}
                                readOnly={false}
                                placeholder={'Введите любое название'}
                            />
                        </Field>
                    </FieldsGroup>
                    <FieldsGroup className={fieldsBlock}>
                        <div className={fieldsBlockTitle}>
                            1. Регионы доставки
                        </div>
                        <RegionsGroups
                            campaign={campaign}
                            region={region}
                            settings={region.settings}/>
                    </FieldsGroup>
                </React.Fragment>
            )
        }

        if (isActive) {
            content = (
                <div className={regionContent}>
                    {createRegionContent}
                    <FieldsGroup className={fieldsBlock}>
                        <div className={fieldsBlockTitle}>
                            2. Склады
                        </div>
                        <Field label="Выбрать склады для региона">
                            <Select
                                options={RegionStockSelectionOptions}
                                value={this.state.stocks_option}
                                onChange={e => this.changeFieldValue('stocks_option', e.target.value)}
                            />

                            {
                                this.state.stocks_option === 'SELECTED_STOCKS' ? (
                                    <RegionCatalogStocksSelect context={context} region={region}/>
                                ) : (null)
                            }

                            <Hint>Наличие и остаток товаров будет определятся по выбранным складам.</Hint>
                        </Field>
                    </FieldsGroup>
                    <FieldsGroup className={fieldsBlock}>
                        <div className={fieldsBlockTitle}>
                            3. Способы доставки
                        </div>
                        <Checkbox
	                          className={checkboxBlock}
                            checked={this.state.courierAllowed}
                            onChange={e => this.changeFieldValue('courierAllowed', e.target.checked)}
                        >
                            <div>Курьерская доставка</div>
                        </Checkbox>
                        {this.state.courierAllowed && (
                            <div className={tableBlock}>
                                <table className={table}>
                                    <thead>
                                        <tr>
                                            <th>Сроки доставки</th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className={periodBlock}>
                                                    <InputText
                                                        defaultValue={this.state.courierFromDate}
                                                        onChange={e => this.changeFieldValue('courierFromDate', e.target.value)}
                                                        disabled={false}
                                                        readOnly={false}
                                                        placeholder={'0'}
                                                    /> -
                                                    <InputText
                                                        defaultValue={this.state.courierToDate}
                                                        onChange={e => this.changeFieldValue('courierToDate', e.target.value)}
                                                        disabled={false}
                                                        readOnly={false}
                                                        placeholder={'0'}
                                                    />
                                                    дней
                                                </div>
                                            </td>
                                            <td>
                                                <div className={periodBlock}>
                                                    <span className={timeSpan}>
                                                        действуют при заказе до:
                                                    </span>
                                                    <TimeField
                                                        className={timeInput}
                                                        value={this.state.courierOrderTime}
                                                        onChange={e => this.changeFieldValue('courierOrderTime', e.target.value)}
                                                    />
                                                </div>
                                            </td>
                                            <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                                        </tr>
                                    </tbody>
                                </table>
                                  <table className={table}>
                                      <thead>
                                      <tr>
                                          <th>Интервалы доставки</th>
                                          <th></th>
                                          <th className={dayCell}>Пн</th>
                                          <th className={dayCell}>Вт</th>
                                          <th className={dayCell}>Ср</th>
                                          <th className={dayCell}>Чт</th>
                                          <th className={dayCell}>Пт</th>
                                          <th className={dayCell}>Сб</th>
                                          <th className={dayCell}>Вс</th>
                                          <th className={dayCell}></th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      {this.state.intervals.map((interval, key) => (
                                          <tr key = {key} className={(this.state.errors.indexOf(key) >= 0) ? trError : ''}>
                                              <td>
                                                  <div className={periodBlock}>
                                                      c <InputText
                                                          defaultValue={interval.timeFrom.split(':')[0]}
                                                          onChange={e => this.changeTimeValue(key,'timeFrom', 0, e.target.value)}
                                                          disabled={false}
                                                          readOnly={false}
                                                          placeholder={'00'}
                                                      /> :
                                                      <InputText
                                                          defaultValue={interval.timeFrom.split(':')[1]}
                                                          onChange={e => this.changeTimeValue(key,'timeFrom', 1, e.target.value)}
                                                          disabled={false}
                                                          readOnly={false}
                                                          placeholder={'00'}
                                                      />
                                                  </div>
                                              </td>
                                              <td>
                                                  <div className={periodBlock}>
                                                    до <InputText
                                                        defaultValue={interval.timeTo.split(':')[0]}
                                                        onChange={e => this.changeTimeValue(key,'timeTo', 0, e.target.value)}
                                                        disabled={false}
                                                        readOnly={false}
                                                        placeholder={'00'}
                                                    /> :
                                                    <InputText
                                                        defaultValue={interval.timeTo.split(':')[1]}
                                                        onChange={e => this.changeTimeValue(key,'timeTo', 1, e.target.value)}
                                                        disabled={false}
                                                        readOnly={false}
                                                        placeholder={'00'}
                                                    />
                                                  </div>
                                              </td>
                                              <td className={dayCell}><Checkbox
                                                  checked={interval.days[1]}
                                                  onChange={e => this.changeDaysValue(key,1, e.target.checked)}
                                              /></td>
                                              <td className={dayCell}><Checkbox
                                                  checked={interval.days[2]}
                                                  onChange={e => this.changeDaysValue(key,2, e.target.checked)}
                                              /></td>
                                              <td className={dayCell}><Checkbox
                                                  checked={interval.days[3]}
                                                  onChange={e => this.changeDaysValue(key,3, e.target.checked)}
                                              /></td>
                                              <td className={dayCell}><Checkbox
                                                  checked={interval.days[4]}
                                                  onChange={e => this.changeDaysValue(key,4, e.target.checked)}
                                              /></td>
                                              <td className={dayCell}><Checkbox
                                                  checked={interval.days[5]}
                                                  onChange={e => this.changeDaysValue(key,5, e.target.checked)}
                                              /></td>
                                              <td className={dayCell}><Checkbox
                                                  checked={interval.days[6]}
                                                  onChange={e => this.changeDaysValue(key,6, e.target.checked)}
                                              /></td>
                                              <td className={dayCell}><Checkbox
                                                  checked={interval.days[0]}
                                                  onChange={e => this.changeDaysValue(key,0, e.target.checked)}
                                              /></td>
                                              <td className={dayCell}>
                                                  {(key !== 0 && <a onClick={() => this.onDeleteInterval(key)}>
                                                    <Iconui name={"delete"} />
                                                  </a> )}
                                              </td>
                                          </tr>
                                          ))
                                      }
                                      </tbody>
                                  </table>
                                    {(this.state.errors.length > 0 && <Hint error={true}>{this.state.error_message}</Hint>)}
                                    <div className={addPointBlock}>
                                        <a onClick={() => this.onAddInterval()}>
                                            <Iconui name={"add"}/>Добавить интервал
                                        </a>
                                    </div>
                                <div className={orderMethodBlock}>
                                    <span>Способ доставки, который будет выбран в созданном заказе: </span>
                                    <Select
                                        options={context.delivery_methods}
                                        value={this.state.deliveryId}
                                        onChange={e => this.changeFieldValue('deliveryId', e.target.value)}
                                    />
                                </div>
                            </div>
                        )
                        }
                        <Checkbox
	                          className={checkboxBlock}
                            checked={this.state.pickupAllowed}
                            onChange={e => this.changeFieldValue('pickupAllowed', e.target.checked)}
                        >
                            <div>Самовывоз</div>
                        </Checkbox>
                        {this.state.pickupAllowed && (
                            <div className={tableBlock}>
                                <InputText
                                    className={textInput}
                                    defaultValue={this.state.query}
                                    onChange={e => this.loadPvzByQuery(e.target.value)}
                                    disabled={false}
                                    readOnly={false}
                                    placeholder={'Фильтр'}
                                    maxLength={50}
                                />
                                <table className={table}>
                                    <thead>
                                    <tr>
                                        <th>Название точки выдачи</th>
                                        <th>ID</th>
                                        <th>Сроки</th>
                                        <th></th>
                                        <th>Пн</th>
                                        <th>Вт</th>
                                        <th>Ср</th>
                                        <th>Чт</th>
                                        <th>Пт</th>
                                        <th>Сб</th>
                                        <th>Вс</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.pvzList.map((pvz, idx) => (
                                        <tr key={pvz.id ? pvz.id : idx + pvz.pvz_id}>
                                            <td>
                                                <InputText
                                                    className={textInput}
                                                    defaultValue={pvz.name}
                                                    onChange={e => this.changePvz(idx, 'name', e.target.value)}
                                                    disabled={false}
                                                    readOnly={false}
                                                    placeholder={'Наименование'}
                                                    maxLength={50}
                                                />
                                            </td>
                                            <td>
                                                <InputText
                                                    className={textInput}
                                                    defaultValue={pvz.pvz_id}
                                                    onChange={e => this.changePvz(idx, 'pvz_id', e.target.value)}
                                                    disabled={false}
                                                    readOnly={false}
                                                    placeholder={'ID'}
                                                />
                                            </td>
                                            <td>
                                                <InputText
                                                    className={dayInput}
                                                    defaultValue={pvz.fromDate}
                                                    onChange={e => this.changePvz(idx, 'fromDate', e.target.value)}
                                                    disabled={false}
                                                    readOnly={false}
                                                    placeholder={'0'}
                                                />{" - "}
                                                <InputText
                                                    className={dayInput}
                                                    defaultValue={pvz.toDate}
                                                    onChange={e => this.changePvz(idx, 'toDate', e.target.value)}
                                                    disabled={false}
                                                    readOnly={false}
                                                    placeholder={'0'}
                                                />
                                                {" дней"}
                                            </td>
                                            <td>
                                                <div className={periodBlock}>
													<span className={timeSpan}>
														действуют при заказе до:
													</span>
                                                    <TimeField
                                                        className={timeInput}
                                                        value={pvz.time}
                                                        onChange={e => this.changePvz(idx, 'time', e.target.value)}
                                                    />
                                                </div>
                                            </td>

                                            <td><Checkbox
                                                checked={pvz.pickupDays[1]}
                                                onChange={e => this.changePickupDaysValue(idx, 1, e.target.checked)}
                                            /></td>
                                            <td><Checkbox
                                                checked={pvz.pickupDays[2]}
                                                onChange={e => this.changePickupDaysValue(idx, 2, e.target.checked)}
                                            /></td>
                                            <td><Checkbox
                                                checked={pvz.pickupDays[3]}
                                                onChange={e => this.changePickupDaysValue(idx, 3, e.target.checked)}
                                            /></td>
                                            <td><Checkbox
                                                checked={pvz.pickupDays[4]}
                                                onChange={e => this.changePickupDaysValue(idx, 4, e.target.checked)}
                                            /></td>
                                            <td><Checkbox
                                                checked={pvz.pickupDays[5]}
                                                onChange={e => this.changePickupDaysValue(idx, 5, e.target.checked)}
                                            /></td>
                                            <td><Checkbox
                                                checked={pvz.pickupDays[6]}
                                                onChange={e => this.changePickupDaysValue(idx, 6, e.target.checked)}
                                            /></td>
                                            <td><Checkbox
                                                checked={pvz.pickupDays[0]}
                                                onChange={e => this.changePickupDaysValue(idx, 0, e.target.checked)}
                                            /></td>

                                            <td>
                                                <a onClick={() => this.onDeletePvz(idx)}>
                                                    <Iconui name={"delete"} />
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                {this.state.pvzPageCount > 1 &&
                                    <div className={paginateCompare}>
                                        <ReactPaginate
                                            previousLabel={'Предыдущая'}
                                            nextLabel={'Следующая'}
                                            pageCount={this.state.pvzPageCount}
                                            pageRangeDisplayed={2}
                                            marginPagesDisplayed={2}
                                            initialPage={this.state.pvzPage}
                                            onPageChange={({selected}) => {
                                                this.loadPvzInfo(selected)
                                            }
                                            }
                                        />
                                    </div>}
		                            <div className={addPointBlock}>
	                                <a onClick={() => this.onAddPvz()}>
	                                    <Iconui name={"add"}/>Добавить точку доставки
	                                </a>
		                            </div>
                                <div>
                                    <span>Способ доставки, который будет выбран в созданном заказе: </span>
                                    <Select
                                        options={context.delivery_methods}
                                        value={this.state.pickupId}
                                        onChange={e => this.changeFieldValue('pickupId', e.target.value)}
                                    />
                                    <span className={clearPvzListBtn}>
                                        <Iconui name={"delete"}/>
                                        <a onClick={() => this.clearPvzList()}>
                                            Удалить все
                                        </a>
                                    </span>
                                    <a className={importExport} href="?action=importexport#/pokupki" target="_blank">
                                        <Iconui name={"sync"}/>Импорт/экспорт
                                    </a>
                                </div>
                            </div>)}
                    </FieldsGroup>
                    <FieldsGroup className={fieldsBlock}>
                        <div className={fieldsBlockTitle}>
                            4. Способы оплаты
                        </div>
                        <table className={`${methodsTable} ${'zebra'}`}>
                            <thead>
                            <tr>
                                <th>
                                    Доступен для покупателя
                                </th>
                                <th>
                                    Будет выбрано в заказе
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {context.payment_methods.map((method) => {
                                const {value, label} = method
                                return (
                                    <tr key={value}>
                                        <td>
                                            <Checkbox
                                                checked={this.state.payment_methods.indexOf(value) >= 0}
                                                onChange={e => this.togglePayments(value, e.target.checked)}
                                            >
                                                {label}
                                            </Checkbox>
                                        </td>
                                        <td>
                                            <Select
                                                options={context.shop_payment_methods}
                                                value={this.state.paymentIds[value]}
                                                onChange={e => this.changePaymentsIds(value, e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </FieldsGroup>
                    {createAddButton}
                </div>
            )
        }

        return (
            <div className={regionBlock}>
                <RegionHeader title={region.name} isHome={isHome} isNew={isNew} onDeleteRegion={this.onDeleteRegion}
                              id={region.id}
                              onSelectRegion={this.onSelectRegion}/>
                {content}
            </div>
        )
    }
}